import { Placement } from '@popperjs/core';
import { Modifier } from 'react-popper';

export const getFallbackPlacements = (placement: Placement): Array<Placement> | null => {
  switch (placement) {
    case 'top': {
      return ['bottom', 'right', 'left'];
    }
    case 'bottom': {
      return ['top', 'right', 'left'];
    }
    case 'left': {
      return ['right', 'bottom', 'top'];
    }
    case 'right': {
      return ['left', 'bottom', 'top'];
    }
    default: {
      return null;
    }
  }
};

export const sameWidthModifier = {
  name: 'sameWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: ({ state }) => {
    state.styles.popper.width = `${state.rects.reference.width}px`;
  },
  effect: ({ state }) => {
    state.elements.popper.style.width = `${(state.elements.reference as HTMLElement).offsetWidth}px`;
  },
} as Modifier<'sameWidth'>;
